export default {
  props: {
    second: Boolean
  }
};